import React from 'react';
import PropTypes from 'prop-types';
import styles from './Skeleton.css';
import TextLine from './TextLine';

const TextSkeleton = ({ lineCount = 4, justified = false }) => {
  let lines = [];
  for (let i = 0; i < lineCount; i++) {
    let className;
    if (i === lineCount - 1) {
      className = justified ? styles.text : styles.shortened;
    }
    lines.push(<TextLine className={className} key={i} />);
  }
  return <p>{lines}</p>;
};

TextSkeleton.displayName = 'TextSkeleton';

TextSkeleton.propTypes = {
  /** define the line count */
  lineCount: PropTypes.number,
  /** define if the text should be justified */
  justified: PropTypes.bool,
};

export default TextSkeleton;
